// extracted by mini-css-extract-plugin
export default {"tasks":"wO-z","task":"xO-z","svg":"yO-z","text":"zO-z"};